module.exports = __webpack_public_path__ + "img/big-apteka-gemini.8b66e59b.png";